import React from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen-mobile';

import styles from './InfoListItem.module.scss';

type TypeInfoListItemProps = {
  idx: number;
  title?: string;
  customTitle?: React.ReactNode;
  subTitle?: React.ReactNode;
  description?: string;
  onClick?: () => void;
  rightElement?: React.ReactNode;
};

/**
 * @description 리스트 아이템 컴포넌트
 */
const InfoListItem = ({
  idx,
  title,
  customTitle,
  subTitle = '',
  description = '',
  rightElement = undefined,
}: TypeInfoListItemProps): React.JSX.Element => {
  return (
    <React.Fragment key={String(title)}>
      {idx > 0 && <Divider orientation="horizontal" color="gray100" />}
      <li className={styles['info-list-item-container']}>
        <div className={styles['info-list-item']}>
          {customTitle || (
            <Text size="xlarge" weight="semi-bold">
              {title}
            </Text>
          )}
          {subTitle}
          <Text size="large" color="tertiary">
            {description}
          </Text>
        </div>
        {rightElement}
      </li>
    </React.Fragment>
  );
};

export default InfoListItem;
